const CDN_URL = process.env.REACT_APP_CDN_URL;
const CDN_ROOT = process.env.REACT_APP_CDN_ROOT;
const API_URL = process.env.REACT_APP_API_URL;
const DEBUG = process.env.REACT_APP_DEBUG;
const PLACEHOLDER_IMG = `${window.location.origin}/placeholder.png`;
const PAGE_AUTH = process.env.REACT_APP_PAGE_AUTH;
const PAGE_PUBLIC = process.env.REACT_APP_PAGE_PUBLIC;
const PAGE = window.location.origin;

export {
	API_URL,
	CDN_ROOT,
	CDN_URL,
	DEBUG,
	PLACEHOLDER_IMG,
	PAGE_AUTH,
	PAGE_PUBLIC,
	PAGE,
}